/*
 * The marketing site's two curves, as Motion easing arrays. The same values
 * are Tailwind tokens (`ease-mk`, `ease-mk-in-out` in tailwind.config.js), so
 * a CSS transition and a Motion animation move alike.
 */

/** The strong ease-out: anything entering, leaving or settling. */
export const EASE_MK = [0.16, 1, 0.3, 1];

/** The strong ease-in-out: something already on screen moving to a new place. */
export const EASE_MK_IN_OUT = [0.77, 0, 0.175, 1];

/**
 * The iOS drawer curve: a sheet rising from (or falling back to) the bottom
 * edge, as the app's value drawer does.
 */
export const EASE_DRAWER = [0.32, 0.72, 0, 1];
